// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2d6v3","containerItemsCenter":"Skeleton_containerItemsCenter__33hQV"};